type HighlightDetails = {
  text?: string;
  tooltip?: string;
};

export function getHighlightDetailsByOfferId(
  offerId: string,
  {
    driverBonus,
    driverApy,
    driverMinimumBalance,
  }: {
    driverBonus?: { value?: string; description?: string };
    driverApy?: { value?: string; valueTooltip?: string };
    driverMinimumBalance?: { value?: string };
  },
): HighlightDetails | undefined {
  switch (offerId) {
    case '473eb46a-aefa-11ec-be17-4b2c08a5fefe': // SoFi
      return {
        text: driverBonus?.value && `Earn ${driverBonus.value} bonus`,
        tooltip: driverBonus?.description,
      };

    case '96d74bb6-7cf4-11ef-b0cd-e335c1640983': // Open Bank
      return {
        text: driverApy?.value ? `Earn ${driverApy.value} APY` : 'No monthly fees',
        tooltip: driverApy?.valueTooltip,
      };

    case 'e7dbcbb8-259e-11e8-9c02-53a23c4736b6': // Synchrony
      return {
        text: 'Great ATM Access',
      };

    case 'e7dabbce-259e-11e8-9c02-6ff6cb82cb54': // AMEX
      return {
        text: driverMinimumBalance?.value && `${driverMinimumBalance.value} min. balance`,
      };

    case 'd3166cda-8594-11ef-bd19-133186211472': // Axos
      return {
        text: 'High APY',
      };

    default:
      return undefined;
  }
}
